import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div className="notFound">404 NotFound</div>
      <button className="btn-cls" onClick={() => navigate("/")}>
        Back to Home
      </button>
    </div>
  );
};

export default NotFound;
